module.exports = __webpack_public_path__ + "img/part6-icon4.64e1ba09.png";